import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { standortUrlSelector } from '../../modules/selectors/url';
import { apiClient } from '../../helpers/apiHelperV2';

export function useOfferCategory(categories) {
    const standortUrl = useSelector(standortUrlSelector);
    const [hasOfferCategory, setHasOfferCategory] = useState(false);

    const offerCategory = useMemo(
        () => categories?.find(category => category.url === 'angebote') ?? null,
        [categories]
    );

    useEffect(() => {
        if (!standortUrl) {
            setHasOfferCategory(false);
            return;
        }

        let cancelled = false;

        apiClient
            .get(`/api/v1/standorte/${standortUrl}/angebote`)
            .then(({ data }) => {
                if (!cancelled) {
                    setHasOfferCategory(Boolean(data?.length));
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setHasOfferCategory(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [standortUrl]);

    return {
        offerCategory,
        hasOfferCategory: hasOfferCategory && Boolean(offerCategory),
    };
}
